import API from '../api';

const PATH_PROFILE = '/profile';

const getPermissions = () => API.post<string[]>(`${PATH_PROFILE}/permissions`);

export { getPermissions };
